import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="w-full bg-stone-100 px-5 py-16 sm:py-20" data-id="element-102" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto max-w-xl text-center" data-id="element-103" data-mp="1o5q0yeg183yx">
        <span className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-white text-red-600" data-id="element-104" data-mp="222d9zfl9ekl7">
          <ShieldCheckIcon className="h-6 w-6" aria-hidden="true" data-id="element-105" data-mp="1x5mv2vl6xv1d" />
        </span>
        <h2 className="mt-6 font-serif text-xl font-black uppercase tracking-wide text-stone-900 sm:text-2xl" data-id="element-106" data-mp="19dz8uqyvj85f">
          Recupera tu Dinero o Quédate con el Sistema
        </h2>
        <p className="mt-3 text-sm font-bold text-red-600" data-id="element-107" data-mp="1j4aimu58obk8">
          Tienes 7 días de garantía.
        </p>
        <p className="mx-auto mt-4 max-w-md text-sm leading-relaxed text-stone-600" data-id="element-108" data-mp="1edc0dp0ox3ec">
          Explora INGLÉS LISTO™, revisa los 12 volúmenes y descubre cómo puede
          ayudarte a ahorrar horas de preparación.
        </p>
        <p className="mx-auto mt-3 max-w-md text-sm leading-relaxed text-stone-600" data-id="element-109" data-mp="lodecgtg5h3r">
          Si no es lo que esperabas, puedes solicitar el reembolso dentro del
          período de garantía de acuerdo con nuestra política de devolución.
        </p>
        <a href="#faq" className="mt-5 inline-block text-xs font-bold text-red-600 underline underline-offset-4 transition-colors duration-150 hover:text-red-700" data-id="element-110" data-mp="ypbcpx2il22l">
          Ver política completa de reembolso
        </a>
      </div>
    </section>;
}